'use client'

// The time window of a topic or storyline page (2026-11-01): one pill of
// options, the chosen one solid. Everything under it on the page follows
// it. Shared so the two pages can't drift apart.
export default function PeriodPills({
  options,
  value,
  onChange,
  className = '',
}) {
  if (options.length < 2) return null
  return (
    <div
      role="group"
      aria-label="Time window"
      className={`flex w-fit gap-[3px] rounded-full border border-foreground bg-card p-[3px] ${className}`}
    >
      {options.map((p) => {
        const on = p.id === value
        return (
          <button
            key={p.id}
            type="button"
            aria-pressed={on}
            onClick={() => onChange(p.id)}
            className={`min-h-10 rounded-full px-4 font-sans text-sm font-medium transition-colors ${
              on
                ? 'bg-foreground text-background'
                : 'text-foreground hover:bg-muted'
            }`}
          >
            {p.label}
          </button>
        )
      })}
    </div>
  )
}
